import React from 'react';
import PropTypes from 'prop-types';

import Carousel, { Slide } from '../../../../library/carousel/carousel';
import CmsFeatureArticle from './components/cms-featured-article/cms-featured-article';

import styles from './cms-featured-article-list.scss';

function CmsFeaturedArticleList(props) {
  const { articles } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['article-list']}>
        {Array.isArray(articles) &&
          articles.map((props, idx) => (
            <CmsFeatureArticle isFixedWidth key={`cfal-${idx}`} {...props} />
          ))}
      </div>
      <div className={styles['article-carousel']}>
        <Carousel hasFullWidthSlides showIndicators>
          {Array.isArray(articles) &&
            articles.map((props, idx) => (
              <Slide key={`cfac-${idx}`}>
                <CmsFeatureArticle {...props} />
              </Slide>
            ))}
        </Carousel>
      </div>
    </div>
  );
}

CmsFeaturedArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      heading: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.object,
      link: PropTypes.object
    })
  )
};

export default CmsFeaturedArticleList;
